module.exports = __webpack_public_path__ + "static/media/blankavatar.85baaf45.png";